import { lazy, Suspense, type ReactElement } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/router/ProtectedRoute';
import { RoleRoute } from '@/router/RoleRoute';
import { RouteFallback } from '@/components/shared/RouteFallback';

// BUG-001 (BUGS.md) — route-based code splitting: har bir sahifa alohida chunk.
const HomePage = lazy(() => import('./pages/HomePage').then((m) => ({ default: m.HomePage })));
const ShiftPage = lazy(() => import('./pages/ShiftPage').then((m) => ({ default: m.ShiftPage })));
const AddBatchPage = lazy(() => import('./pages/AddBatchPage').then((m) => ({ default: m.AddBatchPage })));
const StockPage = lazy(() => import('./pages/StockPage').then((m) => ({ default: m.StockPage })));
const IngredientsPage = lazy(() => import('./pages/IngredientsPage').then((m) => ({ default: m.IngredientsPage })));
const DispatchPage = lazy(() => import('./pages/DispatchPage').then((m) => ({ default: m.DispatchPage })));
const CashPage = lazy(() => import('./pages/CashPage').then((m) => ({ default: m.CashPage })));
const StoresPage = lazy(() => import('./pages/StoresPage').then((m) => ({ default: m.StoresPage })));
const StoreDetailPage = lazy(() => import('./pages/StoreDetailPage').then((m) => ({ default: m.StoreDetailPage })));
const StatsPage = lazy(() => import('./pages/StatsPage').then((m) => ({ default: m.StatsPage })));
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((m) => ({ default: m.ProfilePage })));
const NotificationsPage = lazy(() =>
  import('./pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);

function manager(element: ReactElement): ReactElement {
  return (
    <ProtectedRoute>
      <RoleRoute roles={['MANAGER', 'ADMIN']}>
        <Suspense fallback={<RouteFallback />}>{element}</Suspense>
      </RoleRoute>
    </ProtectedRoute>
  );
}

/**
 * F2 — Zam (Manager) ekranlari (M-01…M-12).
 * CLAUDE.md §6 — registry.ts tomonidan avtomatik yig'iladi.
 * Yo'llar `lib/navConfig.ts` dagi NAV_CONFIG.MANAGER bilan mos.
 */
export const routes: RouteObject[] = [
  { path: '/manager', element: manager(<HomePage />) },
  { path: '/manager/shift', element: manager(<ShiftPage />) },
  { path: '/manager/shift/add-batch', element: manager(<AddBatchPage />) },
  { path: '/manager/stock', element: manager(<StockPage />) },
  { path: '/manager/ingredients', element: manager(<IngredientsPage />) },
  { path: '/manager/dispatch', element: manager(<DispatchPage />) },
  { path: '/manager/cash', element: manager(<CashPage />) },
  { path: '/manager/stores', element: manager(<StoresPage />) },
  { path: '/manager/stores/:id', element: manager(<StoreDetailPage />) },
  { path: '/manager/stats', element: manager(<StatsPage />) },
  { path: '/manager/profile', element: manager(<ProfilePage />) },
  { path: '/manager/notifications', element: manager(<NotificationsPage />) },
];
